/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_App_RecentInputs */

const en_nav_app_recent = /** @type {(inputs: Nav_App_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent`)
};

const es_nav_app_recent = /** @type {(inputs: Nav_App_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recientes`)
};

/**
* | output |
* | --- |
* | "Recent" |
*
* @param {Nav_App_RecentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_app_recent = /** @type {((inputs?: Nav_App_RecentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_App_RecentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_app_recent(inputs)
	return en_nav_app_recent(inputs)
});